/**
 * React Router v7 behaviours, opted into early.
 *
 * On v6.28 the router warns once per mounted Router for every v7 change not
 * yet opted into. Once the jest suite started running in CI (#1473) those
 * warnings were the bulk of the log, and a log nobody can read is a log nobody
 * checks. Opting in silences them at the source rather than filtering them, and
 * takes the v7 behaviour now, while there is a test suite watching.
 *
 * Exported as one object so the app router and the test wrappers cannot drift:
 * a test that renders under different router semantics than production is
 * testing something we do not ship.
 *
 * - v7_startTransition: router state updates are wrapped in React.startTransition.
 *   The one Suspense boundary in the app (ClusterScatter's lazy Plotly import)
 *   is inside a route rather than around one, and a newly mounted boundary still
 *   shows its fallback during a transition, so the chart skeleton behaves as before.
 * - v7_relativeSplatPath: changes how relative paths resolve inside splat routes.
 *   This app has one splat route ("*" -> NotFoundPage) and its only link is
 *   absolute, so this flag is a no-op here — taken for the warning, not a change.
 */
export const ROUTER_FUTURE_FLAGS = {
  v7_startTransition: true,
  v7_relativeSplatPath: true,
} as const;
